import { render, staticRenderFns } from "./JournalList.vue?vue&type=template&id=12783ae2&scoped=true"
import script from "./JournalList.vue?vue&type=script&lang=js"
export * from "./JournalList.vue?vue&type=script&lang=js"
import style0 from "./JournalList.vue?vue&type=style&index=0&id=12783ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12783ae2",
  null
  
)

export default component.exports